
import React from "react";
import { formatDollar, parseFloatString, theVal, twoDecimals } from "../../../shared/utility";
import { commissionCalc } from "./CommissionLogic";
import { getUser } from "../../../shared/authValidation";

export const commissionSplitsAssociatePDF = (props) => {
    let showValue = false;
    const usr = getUser();
    if (usr.permObj.hasOwnProperty('Routing view_associate_splits')) {
        showValue = true;
    }

    if (!showValue) return null;
    const acc = props.all_commission_calculations;
    let lessee_tot = 0;
    let lessee_perc_tot = 0;
    let lessor_tot = 0;
    let lessor_perc_tot = 0;
    const name = props.name ? props.name : '';
        
    return `<div class="boxed mt-20">
        <div style="margin-top:20px">
            <h4 style="text-decoration:underline">ASSOCIATE COMMISSION SPLITS ${name} LESSEE</h4>
        </div>
        <div class="the-table" style="margin-top:20px">
            <table>
                <tbody>
                    <tr>
                        <td class="col-30">
                            <strong>Name</strong>
                        </td>
                        <td class="col-30">
                            <strong>Percentage</strong>
                        </td>
                        <td class="col-40">
                            <strong>Value</strong>
                        </td>
                    </tr>
                    ${acc.associate_commission_splits_lessee.map((c, i) => {
                        const whole_perc = c.perc * 100;
                        lessee_tot += c.value;
                        console.log('adding-', whole_perc, lessee_perc_tot);
                        lessee_perc_tot += whole_perc;
                        return `<tr>
                                <td class="col-30">${c.name}</td>
                                <td class="col-30">${parseFloatString(twoDecimals(c.perc * 100))} %</td>
                                <td class="col-40">$${twoDecimals(c.value)}</td>
                            </tr>`;
                    }).join('')}
                    <tr>
                        <td class="col-30">
                            <strong>Total</strong>
                        </td>
                        <td class="col-30">${parseFloatString(twoDecimals(lessee_perc_tot))} %</td>
                        <td class="col-40">$${twoDecimals(lessee_tot)}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div style="margin-top:20px">
            <h4 style="text-decoration:underline">ASSOCIATE COMMISSION SPLITS ${name} LESSOR </h4>
        </div>
        <div class="the-table" style="margin-top:20px">
            <table>
                <tbody>
                    <tr>
                        <td class="col-30">
                            <strong>Name</strong>
                        </td>
                        <td class="col-30">
                            <strong>Percentage</strong>
                        </td>
                        <td class="col-40">
                            <strong>Value</strong>
                        </td>
                    </tr>
                    ${acc.associate_commission_splits_lessor.map((c, i) => {
                        const whole_perc = c.perc * 100;
                        lessor_tot += c.value;
                        console.log('adding-', whole_perc, lessor_perc_tot);
                        lessor_perc_tot += whole_perc;
                        return `<tr>
                                <td class="col-30">${c.name}</td>
                                <td class="col-30">${parseFloatString(twoDecimals(c.perc * 100))} %</td>
                                <td class="col-40">$${twoDecimals(c.value)}</td>
                            </tr>`;
                    }).join('')}
                    <tr>
                        <td class="col-30">
                            <strong>Total</strong>
                        </td>
                        <td class="col-30">${parseFloatString(twoDecimals(lessor_perc_tot))} %</td>
                        <td class="col-40">$${twoDecimals(lessor_tot)}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>`;
}
